var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},_vm._l((_vm.data),function(item,index){return _c('ListItem',{key:index,attrs:{"name":_vm.name,"item-index":index,"data":_vm.data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }